export default "__VITE_ASSET__bb069b5a__"